import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import axios from 'axios'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { InputText } from 'primereact/inputtext'
import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import MenubarView from './MenubarView'
import { useEffect, useState,useRef } from 'react'
import { FilterMatchMode } from 'primereact/api'
import { Dialog } from 'primereact/dialog'
import { InputTextarea } from 'primereact/inputtextarea'
import { InputNumber } from 'primereact/inputnumber'
import { Toast } from 'primereact/toast'


const CashView = () => {

const toast = useRef(null)
const [entries, setEntries] = useState(null)
const [selectedEntries, setSelectedEntries] = useState(null)
const [categories,setCategories] = useState(null)
const [categoriesWithIds,setCategoriesWithIds] = useState(null)
const [ownersWithIds,setOwnersWithIds] = useState(null)
const [owners,setOwners] = useState(null)
const [entryDialog,setEntryDialog] = useState(false)
const [total,setTotal] = useState (0.00)
const [count,setCount] = useState (0)
const [dateFilter,setDateFilter] = useState(null)
const [datePlaceHolder,setDatePlaceHolder] = useState(null)
const [filters,setFilters] = useState(
    {ownername: { value: null, matchMode: FilterMatchMode.IN },
    categoryname: { value: null, matchMode: FilterMatchMode.IN },
    amount: { value: null, matchMode: FilterMatchMode.EQUALS },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS }
})
const [entry, setEntry] = useState({
    id:null,
    ownerid: null,
    ownername: null,
    categoryid: null,
    categoryname: null,
    actualdate: null,
    description: null,
    amount: null
})
const adminAccess = (localStorage.getItem('adminAccess')==='true')?true:false
const dataAccess = localStorage.getItem('dataAccess').split(',')


useEffect(() => {
    fetchEntryData()
    fetchCategoryData()
    fetchOwnerData()
}, []) // eslint-disable-line react-hooks/exhaustive-deps

const fetchEntryData = (e) => {
    setEntries(null)
    let startDate = ''
    let endDate = ''  
    let queryString = '' 
    let today = new Date()
    let day = today.getDate() 
    if (day<10) day = '0' + day
    let month = today.getMonth() + 1
    if (month<10) month = '0' + month
    let year = today.getFullYear()
    startDate = year + '' + (month) + '01'
    endDate = year + '' + (month) + '' + day
    setDatePlaceHolder(month + '/01/' + year + ' - ' + month + '/' + day + '/' + year)
    if (e) { 
        if (e[1]!=null){
            startDate = formatDate(e[0])
            endDate = formatDate(e[1])
        }
    }
    queryString = '(actualdate>=' + startDate + ' AND actualdate<=' + endDate + ')'
    const url =   '/v1/cashentries/' + encodeURIComponent(queryString)
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    setEntries(null)
    axios.get(url,config)
    .then(response => response.data.filter(item => 
        dataAccess.includes(item.ownerid.toString())
    ))
    .then(response => setEntries(response))
}


const fetchCategoryData = () => {
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    const url =   '/v1/categoryentries'
    axios.get(url,config)
    .then(response => {
        setCategoriesWithIds(response.data)
        const arr = []
        for(var i in response.data)
            arr.push(response.data[i].name)
        setCategories(arr)
    })  
}

const fetchOwnerData = () => {
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    const url =   '/v1/ownerentries'
    
    axios.get(url,config)
    .then(response => response.data.filter(item => 
        dataAccess.includes(item.id.toString())
    ))
    .then(response => {
        setOwnersWithIds(response)
        const arr = []
        for(var i in response)
            arr.push(response[i].name)
        setOwners(arr)
    })  
}

const onRowEditComplete = (e) => {
    let date = e.newData.actualdate.toString().substring(0,10).includes('-')? e.newData.actualdate.toString().substring(0,10):formatDate(e.newData.actualdate,'-')
    // console.log(e.newData.actualdate.toString().substring(0,10) + '    ' + e.newData.actualdate.toString().substring(0,10).includes('-') + '  ' + date)
    entries.forEach(item => {
        if (item.id === e.newData.id) {
            item.description=e.newData.description
            item.amount=e.newData.amount
            item.categoryname=e.newData.categoryname
            item.ownername=e.newData.ownername
            item.actualdate=date
        }
    })
    let body = 'actualdate=' + date + '&ownerid=' +getOwnerId(e.newData.ownername) + '&categoryid=' + getCategoryId(e.newData.categoryname) + '&amount=' 
        + e.newData.amount + '&description=' + e.newData.description
    
    let uri =   '/v1/updatecashentry/' + e.newData.id
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    axios.post(uri,body,config)
        .catch(err => {
            throw err
    })
}

const amountEditor = (options) => {
    return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value)} mode="currency" currency="USD" locale="en-US" />
}

const amountBodyTemplate = (rowData) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData.amount)
}

const descriptionEditor = (options) => {
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />
}


const categoryEditor = (options) => {
    return (
        <Dropdown
            value={options.value}
            options={categories}
            filter
            onChange={(e) => {
                options.editorCallback(e.value)
            }}
        />
    )
}

const ownerEditor = (options) => {
    return (
        <Dropdown
            value={options.value}
            options={owners}
            onChange={(e) => {
                options.editorCallback(e.value)
            }}
        />
    )
}


const ownerBodyTemplate = (rowData) => {
    return (<div>{rowData.ownername}</div>)
}


const ownerFilterTemplate = (options) => {
    return (
        <MultiSelect
            value={options.value}
            options={owners}
            onChange={(e) => options.filterApplyCallback(e.value)}
            placeholder="Select Accounts"
            className="p-column-filter"
            maxSelectedLabels={1}
            style={{ minWidth: '14rem' }}
        />
    )
}

const categoryBodyTemplate = (rowData) => {
    return (<div>{rowData.categoryname}</div>)
}


const categoryFilterTemplate = (options) => {
    return (
        <MultiSelect
            value={options.value}
            options={categories}
            onChange={(e) => options.filterApplyCallback(e.value)}
            filter
            placeholder="Select Category"
            className="p-column-filter"
            maxSelectedLabels={1}
            style={{ minWidth: '14rem' }}
        />
    )
}


const dateFilterTemplate = () => {      
    return <Calendar id = "range" value={dateFilter}  onChange={(e)=>{setDateFilter(e.target.value)
            fetchEntryData(e.target.value)}} selectionMode="range" monthNavigator yearNavigator yearRange="2010:2030"  showIcon  placeholder={datePlaceHolder} />
}


const dateEditor = (options) => {
    let date = options.rowData.actualdate.toString().substring(0,10)
    return (
        <Calendar value={options.value} 
        onChange={(e) => options.editorCallback(e.target.value)} 
        placeholder={date}
        showIcon/>
    )
} 

const dateBodyTemplate = (rowData) => {
    return rowData.actualdate.toString().substring(0, 10)
}

const formatDate = (value,seperator) => {
    let sp = (seperator === undefined)? '' :  seperator
    let dt = new Date(value)
    let day = dt.getDate() 
    if (day<10) day = '0' + day
    let month = dt.getMonth() + 1
    if (month<10) month = '0' + month
    let year = dt.getFullYear()
    return year + sp + (month) + sp + day
}

const getCategoryId = (name) => {
    let result  = ''
    categoriesWithIds.forEach(item => {
        if (item.name === name) result=item.id})
    return result
}

const getOwnerId = (name) => {
    let result  = ''
    ownersWithIds.forEach(item => {
        if (item.name === name) result = item.id
    })
    return result
}

const reset = () => {
    setFilters(
        {ownername: { value: null, matchMode: FilterMatchMode.IN },
        categoryname: { value: null, matchMode: FilterMatchMode.IN },
        amount: { value: null, matchMode: FilterMatchMode.EQUALS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    
}

const deleteSelectedEntries = () =>{
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    let succeeded=true
    selectedEntries.forEach(item => {
        var uri =   '/v1/deletecashentry/' + item.id
        axios.post(uri,{},config)
        .catch(err => {
            succeeded=false
            throw err
        })
    })
    if (succeeded) {
        let es = entries.filter(entry => !selectedEntries.includes(entry))
        setEntries(es)
        setSelectedEntries(null)
    }
    //toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Entries Deleted', life: 3000 })
}

const openNew = () => {
    setEntryDialog(true)
}

const hideDialog = () => {
    setEntryDialog(false)
    setEntry({id:null,
        ownerid: null,
        ownername: null,
        categoryid: null,
        categoryname: null,
        actualdate: null,
        description: null,
        amount: null
    })
}

const addEntry  = () => {
    const dt = new Date(entry.actualdate)
    let day = dt.getDate() 
    if (day<10) day = '0' + day
    let month = dt.getMonth() + 1
    if (month<10) month = '0' + month
    let year = dt.getFullYear()
    let dateString = year + '-' +  month + '-' + day
    entry.actualdate = dateString
    
    let body = 'actualdate=' + dateString + '&ownerid=' + entry.ownerid + '&categoryid=' + entry.categoryid + '&amount=' + entry.amount + '&description=' + entry.description
    let uri =   '/v1/addcashentry'
    
    const token = localStorage.getItem('bearerToken')
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    }
    axios.post(uri,body,config)
        .then(function (response) {
        entry.id = response.data.insertId
        })
        .catch(err => {
            console.error(err)
            throw err
        })
    entries.push(entry)
    hideDialog()
    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Entry Created ', life: 3000 })
}



const calculateTotals = (options) => {
    var t = 0.00
    var c = 0
    options.forEach(item => {
        t += item.amount
        c ++
    })
    setTotal(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(t))
    setCount(c ++)
}

const entryDialogFooter = () => {   
    return (
    <React.Fragment>
        <Toast ref={toast}></Toast>
        <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={addEntry} />
    </React.Fragment>
    )
}

const leftToolbarTemplate = () => {
    if (adminAccess){
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2"  onClick={openNew}/>
                <Button label="Delete" icon="pi pi-trash" className="p-button-danger p-mr-2" onClick={deleteSelectedEntries}/>
                <Button label="Clear" className="p-button-outlined" icon="pi pi-filter-slash" onClick={reset} />
            </React.Fragment>
        )
    } else {
        return (
           <span/>
        )
    }
}

const rightToolbarTemplate = () => {
    if (count === 0) {entries && calculateTotals(entries)}
    return (
        <React.Fragment>
            <div  style={{'textAlign':'left'}}> <span style={{color:'orange', fontWeight:'bold'}}>{count}</span>  entries in total of <span style={{'color':'orange', fontWeight:'bold'}}>{total}</span></div>
        </React.Fragment>
    )
}

const hidden = !adminAccess

return (
    <div>  
        <div><MenubarView/></div>
        <Toolbar className="p-mb-2" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
        <div className="card p-fluid">
            <DataTable value={entries} editMode="row" dataKey="id" filters={filters} filterDisplay="row" paginator rows={50} 
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[50,75,100]} onRowEditComplete={onRowEditComplete} selection={selectedEntries}  
                onSelectionChange={(e) => setSelectedEntries(e.value)} tableStyle={{ minWidth: '50rem' }}
                emptyMessage="No records found."  onValueChange={calculateTotals}>

                <Column hidden={hidden} selectionMode="multiple" headerStyle={{minWidth:'3rem'}}></Column>
                <Column hidden={hidden} rowEditor headerStyle={{ width:'10%', minWidth:'7rem'}} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column hidden={hidden} field="id" header="ID" sortable></Column>
                <Column header="DATE" field="actualdate" dataType="date" filterMatchMode="custom" filter body={dateBodyTemplate} filterElement={dateFilterTemplate} 
                editor={dateEditor}  style={{ minWidth: '20rem' }} sortable></Column>
                <Column header="AMOUNT" field="amount" dataType="numeric" editor={amountEditor} body={amountBodyTemplate} filter filterPlaceholder="Search by Amount" sortable style={{ minWidth: '14rem' }}></Column>
                <Column header="CATEGORY" field="categoryname" filterField="categoryname" showFilterMenu={false} sortable style={{ minWidth: '14rem' }}
                body={categoryBodyTemplate} filter filterElement={categoryFilterTemplate} editor={categoryEditor}/>
                <Column header="ACCOUNT" field="ownername" filterField="ownername" showFilterMenu={false} sortable  style={{ minWidth: '14rem' }}
                body={ownerBodyTemplate} filter filterElement={ownerFilterTemplate} editor={ownerEditor} />
                <Column header="DESCRIPTION" field="description" editor={descriptionEditor} filter filterPlaceholder="Search by Description" style={{ width: '30%' }} sortable></Column>
                
            </DataTable>
        </div>
        <div>
        <Dialog visible={entryDialog} style={{ width: '600px'}} header="Cash Entry" modal  footer={entryDialogFooter} onHide={hideDialog}> 
            <div className="p-field p-col-12 p-md-48">
                <span className="p-float-label">
                    <Dropdown id="entryDialogCategoryField" style={{'textAlign':'left', 'minWidth': '14rem'}} value={entry.categoryname} options={categories} 
                    onChange={
                        (e) => setEntry({...entry,categoryid:getCategoryId(e.target.value),categoryname:e.target.value
                        })
                    }
                    />
                    <label htmlFor="entryDialogCategoryField">Select Category</label>
                </span>
            </div>
            <div className="p-field p-col-12 p-md-48">
                <span className="p-float-label">
                    <Dropdown id="entryDialogOwnerField" style={{'textAlign':'left', 'minWidth': '14rem'}} value={entry.ownername} options={owners} 
                    onChange={
                        (e) => setEntry({...entry,ownerid:getOwnerId(e.target.value),ownername:e.target.value
                        })
                    }
                    />
                    <label htmlFor="entryDialogOwnerField">Select Account</label>
                </span>
            </div>
            <div className="p-field p-col-12 p-md-48">
                <span className="p-float-label">
                    <InputText id="entryDialogAmountField" value={entry.amount} onChange={(e) => setEntry({...entry,amount:e.target.value})}/>
                    <label htmlFor="entryDialogAmountField">Enter Amount</label>
                    <Calendar id="entryDialogDateField" value={entry.actualdate} onChange={(e) => setEntry({...entry,actualdate:e.target.value})} monthNavigator yearNavigator yearRange="2010:2030"  showIcon/>
                </span>
            </div>
            <div className="p-field p-col-12 p-md-24">
                <span className="p-float-label">
                <InputTextarea id="entryDialogDescriptionField" value={entry.description} onChange={(e) => setEntry({...entry,description:e.target.value})} rows={16} cols={40} />
                <label htmlFor="entryDialogDescriptionField">Enter Description</label>
                </span>
            </div>
            <div className="p-field p-col-12 p-md-24">
                <span className="p-float-label">
                        
                </span>
            </div>
        </Dialog>
        </div>
    </div>
)
}
export default CashView